<template>
  <div id="LiveTripRoute">
    <GmapMap :center="{lat:21.1702,lng:72.8311}" :options="options" :zoom="12"
             style="width: 100%; height: 80vh">
      <GmapPolyline :path="tripPath" ref="polyline"></GmapPolyline>
    </GmapMap>
  </div>
</template>

<script>
export default {
  name: 'LiveTripRoute',
  props: [],
  data () {
    return {
      options: {
        zoomControl: true, mapTypeControl: true, scaleControl: true,
        streetViewControl: false, rotateControl: false, fullscreenControl: true,
        disableDefaultUI: false,
      },
      tripPath: [
        { lat: 1.33, lng: 103.75 },
      ],
    }
  },
}
</script>

<style scoped>

</style>
